<template>
  <div class="nav-bar clearfix">
    <div class="logo clearfix">
      <router-link to="/" target="">
        <img
          style="vertical-align: middle"
          src="@/assets/logo.png"
          alt="易极云课堂"
        />
      </router-link>
    </div>
    <div class="nav-group clearfix">
      <router-link
        class="nav-item hoverStyle"
        to="/CourseClassify"
        target="_blank"
        >{{ $t("nav.sourseClassify") }}</router-link
      >
      <!--<a class="nav-item hoverStyle" href="javascript:void(0)" @click="showReg()">{{ $t('nav.sourseClassify') }}</a>-->
      <router-link
        class="nav-item hoverStyle"
        :to="{ path: '/OrganClassify', query: goOrganClassfyParam }"
        target="_blank"
        >{{ $t("nav.organClassify") }}</router-link
      >

      <!-- <a class="nav-item hoverStyle" href="javascript:void(0)" @click="showReg()">{{ $t('nav.broadcastLive') }}</a> -->
      <a
        class="nav-item a-link"
        href="javascript:void(0)"
        @click="download($event)"
        id="box"
        ref="box"
        >{{ $t("nav.downloadApp") }}</a
      >
      <!---->
      <!--<a class="nav-item importor" style="display:inline-block; width: 165px">{{ $t('nav.importor') }}</a>-->

      <!-- <router-link
        class="nav-item importor"
        style="display:inline-block; width: 165px"
        to="/merchants"
        target="_blank"
        >{{ $t("nav.importor") }}</router-link
      > -->

      <!-- <router-link class="nav-item hoverStyle" to="/aboutus" target="_blank">{{
        $t("nav.train")
      }}</router-link> -->
    </div>

    <div class="search-wrapper">
      <search></search>
    </div>
    <transition name="fade">
      <download-code
        class="download-code"
        v-show="downloadShow"
      ></download-code>
    </transition>
  </div>
</template>

<script>
import Search from "./components/search.vue";
import DownloadCode from "./components/download-code";
import mixin from "@/components/mixin/mixin.vue";
import { mapGetters } from "vuex";

export default {
  mixins: [mixin],
  data() {
    return {
      downloadShow: false,
      goOrganClassfyParam: {
        orgTypeId: "0",
        pageNo: 1
      }
    };
  },
  computed: {
    ...mapGetters(["userId"])
  },
  components: {
    Search,
    DownloadCode
  },
  downloadShow() {},

  created() {
    // console.log('这儿是nav的created');
    document.addEventListener("click", e => {
      if (!this.$refs.box.contains(e.target)) {
        this.downloadShow = false;
      }
    });
  },
  methods: {
    download: function(e) {
      this.downloadShow = true;
    },
    showReg() {
      this.$alert("   正在开发中！", "敬请期待 ", {
        confirmButtonText: "确定"
      });
    }
  },
  watch: {
    userId(val) {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import "~@/styles/base.scss";
.nav-bar {
  float: left;
  width: 100%;
  min-width: 1260px;
  height: 100px;
  font: 16px/100px microsoft yahei;
  box-shadow: 0 1px 10px #efefef;
  background: $navBgc;
  position: relative;
  .logo {
    float: left;
    display: block;
    margin: 0 45px 0 20px;
    a {
      display: block;
      text-align: center;
      img {
        /*width: 236px;*/
        line-height: 88px;
        // height: 88px;
      }
    }
  }
  .nav-group {
    float: left;
    .nav-item {
      float: left;
      margin-right: 35px;
      width: 68px;
      color: #4d555d;
      outline-style: none;
      &.router-link-active {
        // background: #ccc;
        font-weight: 700;
        color: #000;
      }
    }
  }
  .importor {
    display: block;
    margin-top: 25px;
    float: left;
    width: 162px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #4d555d;
    background: url(/static/img/bgright.png) 0 0 no-repeat;
    padding-left: 5px;
    background-position: left center;
  }
  .search-wrapper {
    float: right;
    margin-right: 50px;
    margin-top: 40px;
    width: 330px;
    height: 21px;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.15s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .download-code {
    position: absolute;
    z-index: 10;
    top: 100px;
    left: 620px;
  }
  .nav-item:hover {
    color: $layoutBlue !important;
  }
  .a-link:hover {
    color: $layoutBlue !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/nav-bar/nav-bar.vue